// React&NextJS
import React, { useContext, useEffect } from 'react'
// Context&Auth
import { UIContext } from '../../../context/UIContext'
// 3rd party libraries
import { useAnimation, AnimatePresence, motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
// Services&Helper functions
import { useKeyDown } from '../../../hooks/useKeyDown'
// Styles
import s from './Modal.module.scss'
// Components

import Authentication from '../authentication/Authentication'
import { Icon } from '../../core/icon/Icon'

type Props = {
    info?: string
    isOpen?: boolean
    closeModal: Function
    formID?: string
    isLoading?: boolean
}

const AuthModal = ({ isOpen, closeModal }: Props) => {
    const { uiState, setUIState } = useContext(UIContext)
    const [ref, inView] = useInView()
    const controls = useAnimation()

    useEffect(() => {
        if (isOpen) {
            setUIState({ ...uiState, canScroll: false })
        } else {
            setUIState({ ...uiState, canScroll: true })
        }
        return () => {
            setUIState({ ...uiState, canScroll: true })
        }
    }, [isOpen])

    useKeyDown(['Escape'], ({ key }) => {
        if (key === 'Escape') {
            closeModal()
        }
    })

    useEffect(() => {
        if (inView) {
            controls.start('visible')
        }
    }, [inView, controls])

    // const checkIfClosing = (e: React.BaseSyntheticEvent) => {
    //     console.log(e.target)

    //     if (e.target?.parentNode === 'background') {
    //         closeModal()
    //     }
    // }

    if (isOpen) {
        return (
            // @ts-ignore
            <AnimatePresence>
                <motion.div
                    className={s.authBG}
                    // onMouseDown={(e) => checkIfClosing(e)}
                    id="background"
                    ref={ref}
                    animate={isOpen ? 'visible' : 'hidden'}
                    initial="hidden"
                    exit="hidden"
                    transition={{
                        duration: 0.2,
                        ease: 'easeOut',
                        delayChildren: 0.2,
                    }}
                    variants={{
                        visible: {
                            opacity: 1,
                        },
                        hidden: {
                            opacity: 0,
                        },
                    }}
                >
                    <Authentication
                        closeButton={
                            <div
                                className={s.close}
                                onClick={() => closeModal()}
                            >
                                <Icon variant="close" />
                            </div>
                        }
                    ></Authentication>
                </motion.div>
            </AnimatePresence>
        )
    }
    return null
}

export default AuthModal
